import React from "react";
import Button from "./Button";

//TODO: is there a cleaner or more dynamic way to render the grid/columns? 

const DataGrid = (props) => {
  let i = 0; // use for id counter

  // dataGrid will only one or two fixed functions,
  // both function defind in parent file.
  // component will pass back the item key
  // can't pass in using json,
  function defaultButton1Action(e, id) {
    if (props.button1Action === undefined || props.button1Action === null) {

    } else {

      props.button1Action(id);
    }
  }
  // second button action/function
  function defaultButton2Action(e, id) {
    if (props.button2Action === undefined || props.button2Action === null) {

    } else {

      props.button2Action(id);
    }
  }
  
//Empty tag in return (<> and </>) creates a React fragment 
//Allows us to render multiple elements without having a parent container 
//Also helps prevent against invalid HTML (for example, rendering a <td> without having a parent table/tr)
//Reference - https://reactjs.org/docs/fragments.html
  return (
    <> 
      {props.data.map((item, index) => (
        <div>
          <hr className="hr_bch" />
          <div className="dataGrid">
            <div
              className="dataGrid__label"
              style={
                item.label !== undefined && item.label.length > 0
                  ? {}
                  : { display: "none" }
              }
              id={"datagrid_label_" + item.id + "_" + i++}
              //id={item.id+"datagrid"}
            >
              {item.label}
            </div>

            <div
              className="dataGrid__content dataGrid__content--string"
              id={"datagrid_content_" + item.id + "_" + i++}
              style={
                (item.contentType !== undefined &&
                  item.contentType === "string") ||
                item.contentType === ""
                  ? {}
                  : { display: "none" }
              }
            >
              {item.content}
            </div>
            <div
              className="dataGrid__content dataGrid__content--money"
              id={"datagrid_content_" + item.id + "_" + i++}
              style={
                item.contentType !== undefined && item.contentType === "money"
                  ? {}
                  : { display: "none" }
              }
            >
              {item.content}
            </div>
            <div
              className="dataGrid__content dataGrid__content--phone"
              id={"datagrid_content_" + item.id + "_" + i++}
              style={
                item.contentType !== undefined && item.contentType === "phone"
                  ? {}
                  : { display: "none" }
              }
            >
              <a href={`tel:${item.content}`}>{item.content}</a>
            </div>
            <div
              className="dataGrid__content dataGrid__content--email"
              id={"datagrid_content_" + item.id + "_" + i++}
              style={
                item.contentType !== undefined && item.contentType === "email"
                  ? {}
                  : { display: "none" }
              }
            >
              <a href={`mailto:${item.content}`}>{item.content}</a>
            </div>
            <div
              className="dataGrid__content dataGrid__content--link"
              id={"datagrid_content_" + item.id + "_" + i++}
              style={
                item.contentType !== undefined && item.contentType === "link"
                  ? {}
                  : { display: "none" }
              }
            >
              <a href={`${item.content}`}>{item.content}</a>
            </div>

            <div
              className="dataGrid__button1"
              style={
                item.button1Label !== undefined && item.button1Label
                  ? {}
                  : { display: "none" }
              }
            >
              <Button
                text={item.button1Label}
                styleName={
                  item.button1Style !== undefined &&
                  item.button1Style.length > 0
                    ? item.button1Style
                    : "button button--primary"
                }
                id={"datagrid_button_" + item.id + "_" + i++}
                type="submit"
                isDisabled={item.button1IsDisabled}
                onClick={(e) => defaultButton1Action(e, item.id)}
              />
            </div>
            <div
              className="dataGrid__button2"	
              style={
                item.button2Label !== undefined && item.button2Label
                  ? {}
                  : { display: "none" }
              }
            >
              <Button
                text={item.button2Label}
                styleName={
                  item.button2Style !== undefined &&
                  item.button2Style.length > 0
                    ? item.button2Style
                    : "button button--primary"
                }
                id={"datagrid_button_" + item.id + "_" + i++}
                type="submit"
                isDisabled={item.button2IsDisabled}
                onClick={(e) => defaultButton2Action(e, item.id)}
              />
            </div>
          </div>
        </div>
      ))}
      <hr className="hr_bch" />
    </> 
  );
};

export default DataGrid;
